import { Box, Stack, Tooltip, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Editable } from "lib/@components/editable"
import { useMemo, useRef } from "react"
import { useSkills } from "routes/@lib/skills"
import { AuthoringEditSkills } from "../components/authoring-edit-skills"
import { HighlightBox } from "lib/@components/highlightBox"
import uniqolor from "uniqolor"

export function AuthoringSkillSet({ describe, defaultSkillSet, sx }) {
    const { target } = useBoundContext()
    const [skillsIndex] = useSkills()
    const skillSet = skillsIndex[target?.skillSet ?? defaultSkillSet]

    const former = useRef()
    const definition = useMemo(() => {
        former.current = skillSet || former.current
        return former.current
    }, [skillSet])

    const path = `tasks.${target.$sort}.skill`

    return definition ? (
        <Box ml={1} sx={sx} className="skill-set">
            <Editable
                pt={1.4}
                pb={1.4}
                pl={0.1}
                pr={0.1}
                editor={
                    <AuthoringEditSkills>
                        <Tooltip placement="right" arrow title={definition?.Skilling}>
                            <Box
                                aria-label="Skill set"
                                borderRadius={1}
                                textAlign="center"
                                width={48}
                                data-cy="schedule-task-skill-set"
                            >
                                <Box>{definition?.SkillingCode}</Box>
                            </Box>
                        </Tooltip>
                    </AuthoringEditSkills>
                }
            >
                <HighlightBox path="skillSet">
                    <a data-property-path={path} />
                    <Tooltip
                        enterDelay={300}
                        enterNextDelay={300}
                        title={
                            <Stack>
                                <Typography variant="caption" component="div">
                                    Skill Required
                                </Typography>
                                <Typography variant="body2">{definition?.Skilling}</Typography>
                            </Stack>
                        }
                    >
                        <Box
                            p={1}
                            minWidth={44}
                            borderRadius={1}
                            bgcolor={`${uniqolor(definition?.Skilling).color}40`}
                            textAlign="center"
                            position="relative"
                        >
                            {describe ? definition.Skilling : definition?.SkillingCode}
                        </Box>
                    </Tooltip>
                    <a data-property-path-end={path} />
                </HighlightBox>
            </Editable>
        </Box>
    ) : (
        <Box alignSelf="center" sx={{ opacity: 0.5 }} width={38} textAlign="center">
            {target?.skillSet}
        </Box>
    )
}
